import { useState } from 'react';
import axios from 'axios';
import { axiosApi } from '../../api/setupApi';

const useDeleteCIS = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const deleteCIS = async (id) => {
    setLoading(true);
    setError(null);
    setSuccessMessage(null);

    try {
      const response = await axiosApi.delete(`/cisbohol/delete/${id}`);
      setSuccessMessage(response.data.message || 'Deleted successfully');
      console.log(`Deleted CIS data with id: ${id}`);
      return response.data; // Return response data for caller if needed
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to delete CIS');
      console.error('Delete error:', err);
    } finally {
      setLoading(false);
    }
  };

  return { deleteCIS, loading, error, successMessage };
};

export default useDeleteCIS;
